import apiAuthClient from '@/services/apiAuthClient';
import { defaultApplication } from '@/utilities/constants';

import errorHandler from '@/utilities/serverErrorHandler';

export const actions = {
  updateApplication ({ commit, getters, dispatch, rootGetters }, payload) {
    payload.ua_totalamountrequesting = rootGetters['childEntities/getActivityTotalCost'];
    payload.ua_forecastnumberofjobs = rootGetters['childEntities/getTotalJobs'] || payload.ua_forecastnumberofjobs;

    const activeApplication = getters.getActiveApplication;
    const mutation = activeApplication === 'small' ? 'UPDATE_APPLICATION_SMALL' : 'UPDATE_APPLICATION_LARGE';

    payload.ua_businessbanksortcode = payload?.ua_businessbanksortcode?.replace(/-/g, '') || null;

    commit(mutation, payload);

    commit('UPDATE_ADDITIONAL_POSTCODE_FIELDS');

    const application = getters.getApplication;

    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Updating your application...' }, { root: true });
    return apiAuthClient.put('UpdateICApplication', application, rootGetters['auth/getAccessToken']).then((res) => {
      commit(mutation, application);
      if (res.status === 200) {
        return true;
      }
    }).catch((err) => {
      return errorHandler('applicationErrors', err, 'put');
    }).finally(() => {
      dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
    });
  },
  getApplication ({ commit, dispatch, getters, rootGetters }) {
    dispatch('ui/updateInterstitial', { isLoading: true, message: 'Finding your application...' }, { root: true });
    const applications = [];
    const { large, small } = rootGetters['eoi/getApplicationTypes'];

    if (small) {
      applications.push(apiAuthClient.get(`geticapplication/${process.env.VUE_APP_CONTRACT_ID_SMALL}`, rootGetters['auth/getAccessToken']).then(res => {
        if (res.status === 200) {
          commit('UPDATE_APPLICATION_SMALL', res.data);
          dispatch('settings/updateDownloadedFlag', { flagName: 'appDownloaded', flagStatus: true }, { root: true });
          return 'small';
        }
      }).catch((err) => {
        return errorHandler('applicationErrors', err);
      }));
    }

    if (large) {
      applications.push(apiAuthClient.get(`geticapplication/${process.env.VUE_APP_CONTRACT_ID_LARGE}`, rootGetters['auth/getAccessToken']).then(res => {
        if (res.status === 200) {
          commit('UPDATE_APPLICATION_LARGE', res.data);
          dispatch('settings/updateDownloadedFlag', { flagName: 'appDownloaded', flagStatus: true }, { root: true });
          return 'large';
        }
      }).catch((err) => {
        return errorHandler('applicationErrors', err);
      }));
    }
    if (applications.length) {
      return Promise.all(applications).then((res) => {
        return res;
      })
      .finally(() => {
        dispatch('ui/updateInterstitial', { isLoading: false, message: '' }, { root: true });
      });
    }
  },
  updateCurrentStep ({ commit }, payload) {
    commit('UPDATE_CURRENT_STEP', payload);
  },
  resetApp ({ commit, getters }) {
    const activeApplication = getters.getActiveApplication;
    const mutation = activeApplication === 'small' ? 'UPDATE_APPLICATION_SMALL' : 'UPDATE_APPLICATION_LARGE';
    commit(mutation, defaultApplication);
  },
  prefillApplication ({ commit, dispatch, rootGetters, getters }) {
    const payload = rootGetters['eoi/getEOI'];
    commit('PREFILL_APPLICATION', payload);

    const application = getters.getApplication;

    dispatch('updateApplication', application);
  },
  setActiveApplication ({ commit }, payload) {
    commit('UPDATE_ACTIVE_APPLICATION', payload);
  }
};
